import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AplicacionTipoFormComponent } from './form/aplicacion-tipo-form.component';
import { AplicacionTipoListComponent } from './list/aplicacion-tipo-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'src/app/custom-components/dialog/dialog.module';
import { MaterialModule } from 'src/app/material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomHeaderModule } from 'src/app/custom-components/custom-header/custom-header.module';
import {AplicacionTipoRoutingModule} from './aplicacion-tipo-routing.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import {AplicacionTipoService} from './aplicacion-tipo.service';


@NgModule({
  declarations: [
    AplicacionTipoFormComponent,
    AplicacionTipoListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    MaterialModule,
    CustomHeaderModule,
    FlexLayoutModule,
    AplicacionTipoRoutingModule,
    RouterModule,
    SharedModule,
  ],
  providers: [AplicacionTipoService]
})
export class AplicacionTipoModule { }
